'use client';

import { FaTelegram } from 'react-icons/fa';
import { FaTshirt } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import {
  MERCH_LINK,
  TELEGRAM_LINK,
  TWITTER_LINK,
  WEBSITE_LINK,
} from 'src/links';

const docLinks = [
  { href: MERCH_LINK, title: 'Merch', icon: FaTshirt },
  { href: TELEGRAM_LINK, title: 'Telegram', icon: FaTelegram },
  { href: TWITTER_LINK, title: 'Twitter / X', icon: FaXTwitter },
];

export default function Footer() {
  return (
    <footer className="relative w-full bg-gray-900 backdrop-blur-sm">
      <div className='mx-auto max-w-7xl px-4 py-6'>
        <div className='flex flex-col items-center justify-between gap-4 md:flex-row'>
          {/* Left side - Built by text */}
          <div className="flex items-center">
            <a
              href={WEBSITE_LINK}
              target="_blank"
              rel="noreferrer"
              title="OnchainKit"
              className='text-gray-400 transition-colors duration-200 hover:text-blue-400'
            >
              Built by Boomer on Base
            </a>
          </div>

          {/* Right side - Icon Links */}
          <ul className="flex flex-wrap justify-center gap-6">
            {docLinks.map(({ href, title, icon: Icon }) => (
              <li key={href}>
                <a
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  title={title}
                  className='group flex items-center gap-2 text-gray-400 transition-colors duration-200 hover:text-blue-400'
                >
                  <Icon size={20} />
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
